import { ErrorMessage, Field, useField } from 'formik';
import React from 'react';
import * as FiIcons from 'react-icons/fi';

export interface FormDateInputProps {
  name: string;
  label: string;
  min?: string;
  max?: string;
  required?: boolean;
  disabled?: boolean;
  hint?: string;
  className?: string;
  id?: string;
}

const FormDateInput: React.FC<FormDateInputProps> = ({
  name,
  label,
  min,
  max,
  required,
  disabled,
  hint,
  className = '',
  id,
}) => {
  const [, meta] = useField(name);
  const hasError = meta.touched && !!meta.error;
  const fieldId = id || `date-${name}`;

  return (
    <div className={className}>
      {/* Label */}
      <label
        htmlFor={fieldId}
        className={`block text-sm font-normal mb-2 ${
          hasError ? 'text-error-500' : 'text-monday-text-muted'
        }`}
      >
        {label}
        {required && <span className="form-required-dot"></span>}
      </label>

      {/* Date Input Container */}
      <div className="relative">
        <Field
          type="date"
          name={name}
          id={fieldId}
          min={min}
          max={max}
          disabled={disabled}
          className={`
            mobile-form-input
            w-full
            pr-10
            ${hasError ? 'border-red-500' : ''}
          `}
        />

        {/* Calendar Icon */}
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          {FiIcons.FiCalendar({
            className: `w-4 h-4 ${hasError ? 'text-error-500' : 'text-monday-text-muted'}`
          })}
        </div>
      </div>

      {/* Error Message */}
      <ErrorMessage name={name} component="div" className="text-red-500 text-xs mt-1" />

      {/* Hint */}
      {hint && !hasError && (
        <p className="mt-1 text-xs text-monday-text-muted">{hint}</p>
      )}
    </div>
  );
};

export default FormDateInput;
